module.exports = __webpack_public_path__ + "static/media/mobile_main_bg.778ca3b8.png";